'use client'

import { useIsReactNativeWebView } from '@/lib/react-native/contexts/react-native/ReactNativeProvider.client'
import type { ApolloBrowserXClientValues } from '../services/app.constants'

export function useAppXClientHeader(): ApolloBrowserXClientValues {
  const isInWebview = useIsReactNativeWebView()

  return isInWebview ? 'webview-ecom' : 'web-front'
}
